export const ko = {
    translation: {
        common: {
            trial: "체험판",
            expired: "만료됨",
            renewal: "갱신",
            quantity: "수량",
            error: "오류",
            all: "전체",
            loading: "로딩 중...",
            thank_you: "감사합니다",
            confirm: "확인",
            cancel: "취소",
            save: "저장",
            add: "추가",
            edit: "수정",
            delete: "삭제",
            warning: "경고",
            delete_confirm_text: "이 작업은 되돌릴 수 없습니다. 정말 삭제하시겠습니까?",
            click_to_select: "선택...",
            unit: "단위",
            detail: "상세",
            done: "완료",
            search: "검색",
            processing: "처리 중...",
            success: "성공",
            total: "합계",
            none: "없음"
        },
        roles: {
            admin: "관리자",
            barista: "바리스타",
            waiter: "웨이터",
            kitchen: "주방"
        },
        auth: {
            user_not_found: "사용자를 찾을 수 없습니다!",
            welcome: "다시 오신 것을 환영합니다",
            subtitle: "로그인하여 카페를 관리하세요",
            google_login: "Google로 로그인",
            apple_login: "Apple로 로그인",
            secure_login: "보안 로그인",
            terms_text: "로그인 시 이용약관 및 개인정보 처리방침에 동의하게 됩니다."
        },
        sidebar: {
            dashboard: "대시보드",
            tables: "테이블",
            staff: "직원 관리",
            loyalty: "CRM 및 로열티",
            qr_menu: "QR 메뉴",
            menu_product: "메뉴 및 상품",
            stock_recipe: "재고 및 레시피",
            reports: "보고서",
            settings: "설정",
            admin_panel: "관리자 패널",
            not_logged_in: "로그인되지 않음",
            click_to_select: "프로필 선택",
            switch_profile: "프로필 전환",
            logout: "로그아웃"
        },
        dashboard: {
            overview: "대시보드 개요",
            today: "오늘",
            system_active: "시스템 활성",
            offline: "오프라인 모드",
            payment_reminder: "결제 알림",
            payment_missing_list: "{{names}}님에 대한 결제가 아직 완료되지 않았습니다.",
            add_expense: "지출 추가",
            daily_revenue: "일일 매출",
            open_tables: "사용 중인 테이블",
            pending_tables: "대기 중인 주문",
            waiting_approval: "승인 대기 중",
            active_staff: "근무 중인 직원",
            hourly_revenue: "시간별 매출",
            hourly_profit: "시간별 이익",
            work_hours: "영업 시간",
            hours_24: "24시간",
            revenue: "매출",
            profit: "이익",
            best_sellers: "베스트셀러",
            support_modal: { other: "기타" },
            weekly_performance: "주간 실적",
            weekly_revenue: "주간 매출",
            increase: "증가",
            decrease: "감소",
            busiest_day: "가장 바쁜 요일",
            view_report: "보고서 보기",
            critical_stock_warning: "재고 위험",
            quick_actions: "빠른 작업",
            x_report: "중간 정산 보고서 (X-Report)",
            sync: "동기화",
            backup: "백업",
            support: "지원",
            help_support: "도움말 및 지원",
            help_desc: "무엇을 도와드릴까요?",
            report_issue: "문제 신고",
            version: "버전",
            topic: "주제",
            technical: "기술적 문제",
            suggestion: "제안",
            other: "기타",
            description: "설명",
            desc_placeholder: "문제를 설명해 주세요...",
            send_report: "신고 보내기"
        },
        tables: {
            status: {
                occupied: "사용 중",
                paid: "결제 완료",
                reserved: "예약됨",
                empty: "빈 테이블"
            },
            alerts: {
                reservation_time: "예약 시간:",
                draft_paid: "결제된 임시 주문",
                draft_unpaid: "임시 주문"
            },
            title: "테이블 배치도",
            tabs: {
                plan: "배치도",
                history: "내역"
            },
            filter: {
                all: "전체"
            },
            actions: {
                finish_edit: "편집 종료",
                edit: "테이블 편집",
                add_table: "테이블 추가",
                quick_pay: "빠른 결제",
                reserve: "예약",
                clear: "초기화"
            },
            card: {
                capacity: "인원",
                just_now: "방금 전",
                total: "합계",
                has_request: "새로운 요청",
                no_order: "주문 없음"
            },
            history: {
                search_placeholder: "주문 번호 또는 테이블 검색...",
                multi_pay: "일괄 결제"
            },
            sections: {
                manage: "구역 관리",
                add_placeholder: "새 구역 이름",
                no_sections: "정의된 구역이 없습니다."
            },
            modal: {
                edit_title: "테이블 수정",
                add_title: "테이블 추가",
                name: "테이블 이름",
                name_placeholder: "예: 테이블 5",
                section: "구역",
                capacity: "인원 제한",
                delete: "테이블 삭제",
                unpaid_warning_title: "미결제 잔액 존재!",
                clear_confirm_title: "테이블을 비우시겠습니까?",
                unpaid_warning_text: "<b>{{name}}</b>에 미결제 잔액이 있습니다. 테이블을 비우면 주문이 초기화됩니다.",
                clear_confirm_text: "정말 <b>{{name}}</b>을(를) 비우시겠습니까?",
                delete_confirm_text: "정말 <b>{{name}}</b>을(를) 삭제하시겠습니까?"
            },
            qr_review: {
                title: "QR 주문 입고",
                subtitle: "{{name}}님의 새로운 요청",
                current_state: "현재 테이블 상태",
                table_empty: "테이블이 비어 있습니다.",
                current_total: "현재 합계",
                incoming_request: "들어온 요청",
                extra_total: "추가 합계",
                reject: "거절",
                overwrite: "덮어쓰기",
                overwrite_desc: "현재 주문 삭제 후 새로 설정",
                merge: "합치기",
                merge_desc: "기존 주문에 추가"
            }
        },
        orders: {
            status: {
                completed: "완료"
            },
            list: {
                ticket_no: "주문 번호",
                date: "날짜/시간",
                table: "테이블/고객",
                method: "결제 수단",
                amount: "금액",
                status: "상태"
            },
            modal: {
                match_error: "결제 총액({{pay}}₺)이 주문 총액({{total}}₺)과 일치하지 않습니다.",
                title: "거래 상세",
                content_title: "주문 내용",
                total_title: "총 금액",
                payment_details: "결제 상세",
                entered_total: "입력된 총액",
                difference: "차액"
            },
            correction: {
                note_placeholder: "예: 직원의 잘못된 입력"
            },
            void_flow: {
                button_update: "상태 업데이트 / 취소",
                button_void: "취소 / 환불",
                title_select: "취소 유형 선택",
                type_cancel: "오류 / 반품",
                type_cancel_desc: "재고 복구",
                type_wastage: "폐기 / 쏟음",
                type_wastage_desc: "재고 차감 (복구 안 함)",
                confirm_cancel_title: "오류/반품으로 표시",
                confirm_wastage_title: "폐기로 표시",
                confirm_cancel_text: "판매를 취소하고 모든 재고를 복구합니다. 계속하시겠습니까?",
                confirm_wastage_text: "판매를 취소하지만 재고는 사용/손실된 것으로 간주합니다. 계속하시겠습니까?",
                confirm: "확인"
            }
        },
        pos: {
            title_quick: "빠른 주문",
            title_no_table: "테이블 없음",
            title_table: "{{name}}",
            search_placeholder: "상품 검색...",
            grid: {
                sold_out: "품절"
            },
            ticket: {
                title: "현재 주문서",
                order_no: "주문 번호",
                new: "신규",
                empty: "장바구니가 비어 있습니다.",
                status: {
                    wastage: "폐기",
                    comp: "서비스",
                    cancelled: "취소됨",
                    paid: "결제됨"
                },
                discount_badge: "할인"
            },
            actions: {
                discount: "할인",
                comp: "서비스",
                void: "폐기",
                cancel: "취소",
                pay: "결제",
                assign_table: "테이블",
                save: "저장",
                waiting_payment: "결제 대기 중",
                close_ticket: "주문서 마감"
            },
            totals: {
                subtotal_net: "소계(공급가액)",
                tax_vat: "세금(VAT)",
                grand_total: "총계",
                tax_exclusive_hint: "(+세금)"
            },
            alerts: {
                table_not_found: "테이블을 찾을 수 없습니다.",
                perm_comp: "서비스를 제공할 권한이 없습니다.",
                perm_void: "품목을 취소할 권한이 없습니다.",
                select_item_error: "품목을 선택해 주세요.",
                paid_item_error: "결제된 품목은 수정할 수 없습니다.",
                split_quantity: "{{count}}개의 품목 중 몇 개를 이동하시겠습니까?",
                invalid_amount: "유효하지 않은 금액입니다.",
                perm_discount: "할인을 적용할 권한이 없습니다.",
                select_discount_item: "할인할 품목을 선택해 주세요.",
                paid_discount_error: "결제된 품목은 할인할 수 없습니다.",
                add_items_first: "먼저 장바구니에 품목을 추가해 주세요.",
                unauthorized: "접근 거부"
            },
            modifier_modal: {
                no_modifiers: "사용 가능한 옵션이 없습니다.",
                multiple: "다중 선택",
                add_to_cart: "장바구니 추가"
            },
            discount_modal: {
                title: "할인 적용",
                percent: "퍼센트",
                amount: "금액",
                comp_100: "서비스 (100%)",
                old_total: "기존 합계",
                new_total: "변경 합계",
                apply: "할인 적용"
            }
        },
        payment: {
            alerts: {
                enter_valid: "유효한 금액을 입력해 주세요.",
                balance_not_zero: "주문서를 마감하려면 잔액이 0이어야 합니다."
            },
            header_order: "주문",
            header_open: "주문서 열기",
            ticket_details: "주문 상세",
            select_all: "전체 선택",
            items_count: "품목 {{count}}개",
            empty_list: "품목 없음",
            remaining_badge: "잔액: {{amount}}",
            recent_transactions: "최근 거래 내역",
            totals: {
                total: "합계",
                paid: "결제액",
                remaining: "잔액"
            },
            amount_to_collect: "받을 금액",
            give_change: "거스름돈",
            return_to_customer: "고객에게 반환",
            methods: {
                cash: "현금",
                card: "신용카드",
                qr: "QR / 모바일 결제",
                other: "식권 카드"
            },
            numpad: {
                all: "전체"
            },
            actions: {
                cancel: "취소",
                close_ticket: "주문서 마감",
                waiting_payment: "결제 대기 중"
            }
        },
        menu: {
            title: "메뉴 관리",
            subtitle: "상품, 가격 및 재고 관리",
            add_new: "상품 추가",
            edit_title: "상품 수정",
            add_title: "상품 추가",
            manage_categories: "카테고리 관리",
            alerts: {
                no_permission: "메뉴 관리 권한이 없습니다.",
                delete_confirm: "정말 이 상품을 삭제하시겠습니까?"
            },
            form: {
                image_select: "이미지 선택",
                image_change: "이미지 변경",
                image_recommendation: "정사각형 포맷 권장",
                image_max_size: "최대 2MB",
                name: "상품명",
                name_placeholder: "예: 라떼",
                category: "카테고리",
                price: "가격",
                stock_tracking: "재고 추적",
                stock_hint: "비활성화하려면 0 입력",
                description: "설명",
                description_placeholder: "재료, 상세 정보...",
                customizable: "커스터마이징 가능 (옵션)"
            },
            categories: {
                title: "카테고리 관리",
                add: "카테고리 추가",
                name: "카테고리명",
                edit: "카테고리 수정",
                delete_confirm: "이 카테고리를 삭제하시겠습니까?"
            }
        },
        categories: {
            all: "전체",
            hot_coffees: "따뜻한 커피",
            cold_coffees: "아이스 커피",
            desserts: "디저트",
            snacks: "스낵",
            barista_special: "스페셜"
        },
        stock: {
            title: "재고 관리",
            subtitle: "재고, 레시피 및 옵션",
            tabs: {
                inventory: "재고 현황",
                recipes: "레시피",
                modifiers: "옵션 관리"
            },
            inventory: {
                total_value: "총 자산 가치",
                sku_count: "SKU 수",
                alerts: "재고 알림",
                search_placeholder: "재고 검색...",
                add_stock: "품목 추가",
                status_critical: "위험",
                status_warning: "부족",
                status_sufficient: "정상",
                table: {
                    name: "이름",
                    supplier: "공급처",
                    amount: "수량",
                    status: "상태",
                    unit_cost: "단가",
                    actions: "작업"
                },
                modal: {
                    edit_title: "재고 수정",
                    add_title: "재고 추가",
                    general_info: "기본 정보",
                    management: "관리",
                    name: "품목명",
                    name_placeholder: "예: 우유",
                    supplier: "공급처",
                    supplier_placeholder: "예: 지역 목장",
                    unit: "단위",
                    alarm_thresholds: "알림 임계값",
                    warning_limit: "부족 알림 한도",
                    critical_limit: "위험 알림 한도",
                    stock_status: "재고 상태",
                    finish_editing: "편집 종료",
                    manual_correction: "수동 조정",
                    current_amount: "현재 수량",
                    unit_cost: "단가",
                    new_purchase: "신규 구매 / 입고",
                    add_amount: "추가 수량",
                    purchase_price: "구매 가격",
                    total: "합계",
                    unit_price: "개당 가격",
                    success_feedback: "업데이트 완료!",
                    calculate_add: "계산 및 추가",
                    avg_cost_note: "* 가중 평균 비용을 계산합니다."
                }
            },
            wastage: {
                title: "폐기 보고",
                subtitle: "{{name}} 폐기 보고 중",
                amount: "수량",
                reason: "사유",
                reason_placeholder: "예: 쏟음, 상함",
                report: "폐기 보고"
            },
            recipes: {
                search_product: "상품 검색...",
                gross_margin: "매출총이익률",
                sale_price: "판매가",
                cost_price: "원가",
                ingredients: "재료",
                no_recipe: "정의된 레시피가 없습니다.",
                add_ingredient: "재료 추가",
                stock_item: "재고 품목",
                amount: "분량",
                unit: "단위"
            },
            modifiers: {
                title: "옵션 그룹",
                new_group: "새 그룹",
                group_name: "그룹 이름",
                selection_type: "선택 유형",
                single: "단일 선택 (라디오)",
                multiple: "다중 선택 (체크박스)",
                options: "옵션들",
                option_name: "옵션 이름",
                option_placeholder: "예: 귀리 우유",
                extra_price: "추가 금액",
                deduct_stock: "재고 차감 (선택 사항)",
                add_option: "옵션 추가",
                group_helper_text: "아래에서 이 그룹의 옵션들을 관리하세요.",
                no_link: "연결 없음",
                stock_optional_label: "재고 (선택 사항)",
                edit_group_title: "그룹 수정",
                allow_multiple_label: "다중 선택 허용 (체크박스)",
                delete_group_confirm: "정말 이 그룹을 삭제하시겠습니까?"
            }
        },
        reports: {
            title: "재무 개요",
            filters: { today: "오늘", week: "이번 주", month: "이번 달", all: "전체" },
            kpi: {
                revenue: "총 매출",
                net_revenue: "순 매출 (세금 제외)",
                tax_collected: "징수된 세금",
                income: "수입",
                expense: "총 지출",
                expense_opr: "운영비",
                expense_stock: "매출원가(COGS)",
                expense_wastage: "폐기 손실",
                profit: "당기순이익",
                profit_opr: "영업이익",
                cash_in_hand: "현금 흐름",
                gross_profit: "매출총이익",
                tickets: "총 주문 건수",
                sales_count: "판매 수량",
                expense_analysis: "지출 분석",
                profit_analysis: "순이익 분석",
                available_in_standard: "스탠다드 플랜에서 사용 가능",
                locked: "잠금됨"
            },
            toggles: {
                stock_cost: "재고 비용",
                wastage: "폐기물",
                operational: "운영 모드",
                net_revenue: "순 매출 (세금)"
            },
            charts: {
                sales_title: "매출 차트 ({{currency}})",
                hourly: "시간별",
                daily: "일별",
                monthly: "월별",
                distribution: "분포",
                category_breakdown: "카테고리별 분석",
                revenue_share: "매출 비중",
                no_data: "데이터 없음.",
                tooltip_revenue: "매출: ",
                tooltip_net_revenue: "순 매출: ",
                tooltip_profit: "이익: "
            },
            transactions: {
                title: "거래 내역",
                count_listed: "{{count}}개의 기록 표시됨",
                table: {
                    ticket_no: "주문 번호",
                    date: "날짜 / 시간",
                    table: "테이블",
                    method: "결제 수단",
                    amount: "금액",
                    status: "상태"
                },
                status: {
                    completed: "완료",
                    cancelled: "취소됨"
                },
                no_records: "선택한 범위 내에 거래 기록이 없습니다."
            },
            x_report: {
                title: "중간 정산 보고서 (X-Report)",
                total_cash: "금고 현금 총액",
                daily_tickets: "오늘의 주문 건수",
                cancelled_trx: "취소된 거래",
                collections: "회수액 (현재)",
                shift_reports: "직원 교대 보고서 (오늘)",
                no_shift: "아직 교대 보고서가 없습니다.",
                total_sales: "총 판매액",
                cash: "현금",
                credit_card: "신용카드",
                qr_mobile: "QR / 모바일",
                meal_card: "식권 카드"
            },
            z_report: {
                title: "일 마감 보고서 (Z-Report)",
                auto_toggle: "자동 Z-Report",
                auto_desc: "00:00 기준",
                close_button: "영업 마감 (Z-REPORT)",
                history_title: "과거 Z-Report",
                no_reports: "아직 보고서가 없습니다.",
                receipt: {
                    title: "Z 리포트",
                    report_no: "보고서 번호",
                    cashier: "판매원",
                    total_sales: "총 판매액",
                    tax_base: "과세 표준",
                    total_tax: "총 세금",
                    payment_details: "결제 상세",
                    cash: "현금",
                    card: "신용카드",
                    other: "기타",
                    end: "--- 마감 ---"
                }
            },
            modals: {
                close_confirm: {
                    title: "영업을 마감하시겠습니까?",
                    text: "이 작업은 <strong>{{count}}</strong>개의 열려 있는 거래를 보관하고 공식 Z-Report를 생성합니다. 되돌릴 수 없습니다.",
                    cancel: "취소",
                    confirm: "확인 및 마감"
                },
                expense: {
                    title: "간편 지출 추가",
                    date: "날짜",
                    category: "카테고리",
                    amount: "금액",
                    description: "설명",
                    optional: "선택 사항...",
                    set_default: "카테고리 기본값으로 설정",
                    last_trx: "최근: {{amount}} ({{date}})"
                },
                processing: {
                    title: "Z-Report 생성 중...",
                    text: "잠시만 기다려 주세요. 일 마감 처리 중입니다..."
                }
            },
            liabilities: {
                pending: "결제 대기 중",
                label_today: "오늘의 지출 비중",
                label_week: "주간 지출 비중",
                label_total: "대기 중인 정기 결제"
            }
        },
        settings: {
            general: "일반 설정",
            titles: {
                general: "일반",
                expenses: "지출",
                modifiers: "옵션",
                developer: "개발자"
            },
            descriptions: {
                general: "시스템, 언어 및 비즈니스 설정",
                expenses: "재무 구성",
                developer: "시뮬레이션 및 테스트 도구"
            },
            subscription: {
                active: "활성",
                inactive: "비활성",
                expired: "만료됨",
                renew: "갱신",
                days_left: "남은 일수",
                next_payment: "다음 결제일",
                period_start: "기간 시작일",
                time_remaining: "남은 시간",
                lite_plan: "라이트 플랜",
                standard_plan: "스탠다드 플랜"
            },
            business_identity: "비즈니스 정보",
            financial: "재무 설정",
            financial_desc: {
                currency_desc: "시스템 전반에서 사용되는 통화 기호",
                pricing_desc: "세금 계산 방식"
            },
            interface: {
                title: "인터페이스",
                scale: "UI 배율 (확대/축소)",
                scale_desc: "화면에 항목이 다 보이지 않거나 너무 작거나 클 경우 배율을 조정하세요.",
                note: "참고:",
                scale_note: "1366px 미만의 화면에서는 자동 스케일링이 항상 활성화됩니다."
            },
            operational: {
                title: "영업 시간 및 교대 근무",
                start_hour: "시작 시간 (0-23)",
                end_hour: "종료 시간 (0-23)",
                info_text: "이 설정은 **대시보드**의 시간별 매출 차트에서 '영업 시간'을 선택했을 때 표시되는 범위를 결정합니다. 또한 직원 교대 보고의 기준점으로 사용됩니다.",
                updated_alert: "영업 시간이 업데이트되었습니다."
            },
            shortcuts: {
                staff_desc: "웨이터, 바리스타 및 관리자 관리"
            },
            backup: {
                title: "데이터 및 백업",
                backup_now: "백업하기",
                backup_desc: "데이터베이스 다운로드 (.json)",
                restore: "복구하기",
                restore_desc: ".json 파일 선택",
                factory_reset: "공장 초기화",
                reset_desc: "모든 데이터가 삭제되고 초기 상태로 돌아갑니다.",
                reset_button: "데이터 초기화",
                success_restore: "백업이 성공적으로 복구되었습니다."
            },
            security: {
                reset_title: "공장 초기화",
                restore_title: "백업에서 복구",
                reset_text: "이 작업은 되돌릴 수 없습니다. 모든 데이터(매출, 상품, 재고)가 영구적으로 삭제됩니다.",
                restore_text: "현재 데이터가 삭제되고 선택한 백업 파일의 데이터가 로드됩니다.",
                admin_required: "관리자 승인 필요",
                enter_pin: "PIN 번호를 입력하세요",
                confirm_reset: "삭제 및 초기화",
                confirm_restore: "복구 시작"
            },
            messages: {
                updated: "설정이 업데이트되었습니다.",
                error: "오류가 발생했습니다."
            },
            sync: {
                title: "클라우드 동기화",
                pending: "{{count}}개의 대기 중인 항목",
                up_to_date: "모든 데이터가 최신 상태입니다",
                button: "지금 동기화"
            }
        },
        financials: {
            title: "재무 설정",
            subtitle: "세율 및 지출 카테고리",
            tabs: {
                taxes: "세금",
                expenses: "지출 항목",
                history: "지출 내역"
            },
            taxes: {
                title: "세율",
                active_rates: "활성 세율",
                rate_name: "세율 이름",
                rate_percent: "세율 %",
                description: "설명",
                add_new: "새 세율 추가",
                category_mapping: "카테고리별 세율 매핑"
            },
            expenses: {
                title: "지출 카테고리",
                add_new: "카테고리 추가",
                category_name: "카테고리 이름",
                description: "설명",
                default_amount: "기본 금액",
                recurring: "정기 지출 (매월)",
                recurring_day: "매월 해당 일",
                distribute_daily: "보고서에 일별로 분산 표시"
            },
            history: {
                title: "지출 내역",
                filter_all: "모든 카테고리",
                no_records: "기록을 찾을 수 없습니다.",
                table: {
                    date: "날짜",
                    category: "카테고리",
                    description: "설명",
                    amount: "금액"
                }
            }
        },
        crm: {
            title: "CRM 및 로열티",
            subtitle: "고객 관리 및 로열티 프로그램",
            give_points: "포인트 증정",
            qr_instruction: "고객의 QR 코드를 스캔하세요",
            generate_qr: "QR 생성",
            qr_description: "고객의 지갑에 포인트를 추가하려면 이 QR 코드를 보여주세요.",
            customer_list: "고객 리스트",
            search_placeholder: "고객 검색...",
            last_visit: "마지막 방문:",
            eligible: "보상 획득 가능!",
            settings_title: "캠페인 설정",
            target_points: "목표 포인트",
            reward_name: "보상 이름",
            preview: "카드 미리보기",
            target_label: "목표",
            coming_soon: "준비 중"
        },
        qr: {
            title: "QR 메뉴",
            subtitle: "디지털 메뉴 및 주문 시스템",
            simulate: "주문 시뮬레이션",
            print_selected: "선택 항목 출력",
            lock: {
                title: "온라인 서비스 잠김",
                desc: "QR 메뉴 및 온라인 주문 기능은 스탠다드 플랜에서 사용할 수 있습니다.",
                upgrade_btn: "플랜 업그레이드"
            },
            print: {
                title: "QR 코드 출력",
                scan_instruction: "스캔하여 메뉴 보기"
            },
            preview: {
                title: "실시간 미리보기",
                network: "네트워크:",
                password: "비밀번호:",
                powered_by: "Powered by KahveInn",
                disclaimer: "* QR 스탠드가 어떻게 보일지에 대한 미리보기입니다.",
                scan_instruction: "메뉴 보려면 스캔"
            },
            settings: {
                general: "일반",
                active: "활성화",
                active_desc: "QR 메뉴 시스템 활성화",
                ordering: "주문 허용",
                ordering_desc: "고객이 직접 주문 가능",
                sound: "소리 알림",
                sound_desc: "새 주문 시 소리 재생",
                design: "디자인",
                header_text: "헤더 텍스트",
                theme_color: "테마 색상",
                wifi_ssid: "Wi-Fi SSID",
                wifi_pass: "Wi-Fi 비밀번호"
            },
            selection: {
                title: "테이블 선택",
                select_all: "전체 선택",
                previewing: "미리보기 중"
            },
            modal: {
                permission_title: "권한 필요",
                permission_text: "소리 알림을 재생하려면 브라우저 권한이 필요합니다.",
                allow_btn: "소리 허용"
            }
        },
        staff: {
            title: "직원 관리",
            subtitle: "직원 및 권한 설정",
            tabs: {
                list: "직원 리스트",
                roles: "역할 및 권한"
            },
            lite_banner: {
                title: "라이트 플랜",
                desc: "고급 직원 관리 기능이 제한됩니다."
            },
            stats: {
                total: "총 직원 수",
                on_duty: "근무 중"
            },
            matrix: {
                person: "직원"
            },
            auto_shift_report: "자동 교대 보고",
            modal: {
                add_title: "직원 추가",
                edit_title: "직원 수정",
                delete: "직원 삭제",
                name: "성함",
                role: "역할",
                pin: "PIN 코드 (4자리)",
                phone: "연락처 (선택 사항)",
                status: "상태",
                status_working: "근무 중",
                status_off: "비번"
            },
            roles_tab: {
                title: "역할",
                subtitle: "역할별 권한 설정",
                permissions: "권한",
                no_permissions: "할당된 권한 없음"
            },
            contact: "연락처",
            status: {
                working: "근무 중",
                offline: "비번"
            },
            permission_matrix: "권한 매트릭스",
            no_pin_permission: "PIN을 보거나 변경할 권한이 없습니다.",
            unauthorized_tooltip: "이 사용자를 편집할 수 없습니다.",
            alerts: {
                no_add_permission: "직원을 추가할 권한이 없습니다.",
                no_edit_others: "본인의 프로필만 수정할 수 있습니다.",
                no_edit_admin: "관리자만 다른 관리자를 수정할 수 있습니다.",
                no_delete_self: "본인을 삭제할 수 없습니다.",
                no_delete_permission: "직원을 삭제할 권한이 없습니다.",
                no_delete_admin: "관리자만 다른 관리자를 삭제할 수 있습니다.",
                delete_confirm: "정말 이 직원을 삭제하시겠습니까?",
                no_status_admin: "관리자만 관리자 상태를 변경할 수 있습니다.",
                only_admin_roles: "관리자만 역할 권한을 변경할 수 있습니다."
            }
        },
        permission_groups: {
            general: "일반",
            sales: "판매",
            management: "관리"
        },
        permissions: {
            VIEW_FINANCIALS: { label: "재무 보기", description: "매출 및 이익 데이터 접근" },
            VIEW_TABLES: { label: "테이블 보기", description: "테이블 배치 및 주문 확인" },
            MANAGE_MENU: { label: "메뉴 관리", description: "상품 추가 및 수정" },
            MANAGE_STOCK: { label: "재고 관리", description: "재고 관리 컨트롤" },
            VIEW_REPORTS: { label: "보고서 보기", description: "보고서 페이지 접근" },
            MANAGE_STAFF: { label: "직원 관리", description: "직원 추가/삭제" },
            MANAGE_SETTINGS: { label: "설정 관리", description: "시스템 구성 설정" },
            VOID_ITEM: { label: "품목 취소", description: "취소 또는 폐기 작업" },
            OFFER_COMP: { label: "서비스 제공", description: "무료 품목 제공 권한" },
            APPLY_DISCOUNT: { label: "할인 적용", description: "주문에 할인 적용" },
            CLOSE_DAY: { label: "영업 마감", description: "Z-Report 생성 권한" }
        },
        setup: {
            business_name: "상호명",
            business_address: "주소",
            manager_name: "관리자 성함",
            manager_hint: "관리자 프로필에 사용될 이름",
            staff_count: "직원 수",
            staff_hint: "예상 직원 수",
            currency: "통화",
            pricing_model: "가격 모델",
            tax_inclusive: "부가세 포함",
            tax_exclusive: "부가세 별도",
            completing: "설정 완료 중...",
            title_1: "환영합니다",
            title_2: "팀 및 관리",
            title_3: "재무 설정",
            desc_1: "비즈니스 정보를 입력해 주세요.",
            desc_2: "팀 구조를 설정해 주세요.",
            desc_3: "통화 및 세금 설정을 선택해 주세요.",
            skip_dev: "건너뛰기 (개발)",
            back: "이전",
            next: "다음",
            finish: "설정 완료",
            placeholders: {
                business_name: "예: KahveInn",
                city: "시 (예: 서울특별시)",
                district: "구 (예: 강남구)",
                address_detail: "도로명, 건물 번호...",
                manager_name: "성함"
            },
            errors: {
                business_name: "상호명을 입력해 주세요.",
                city: "시를 입력해 주세요.",
                district: "구를 입력해 주세요.",
                address_detail: "상세 주소를 입력해 주세요.",
                manager_name: "관리자 성함을 입력해 주세요.",
                staff_count: "유효한 직원 수를 입력해 주세요."
            },
            currencies: {
                try: "터키 리라 (₺)",
                usd: "$ - 미국 달러 ($)",
                eur: "유로 (€)",
                gbp: "영국 파운드 (£)"
            },
            loading_text: "시스템을 준비 중입니다. 잠시만 기다려 주세요."
        }
    }
};